module.exports = __webpack_public_path__ + "static/media/4_l_stolb_22.5_34.26.806be1fe.png";